// 価格体系導線（pricing_flow）のインタラクション制御
// Figma design: @https://www.figma.com/design/SItsOOKohrffLk6zRXpcbO/DBA機能改修?node-id=11697-1163&m=dev

import { ModalManager, DialogAdapter, ModalPriority } from "./modal_manager";

document.addEventListener('DOMContentLoaded', () => {
  initializePricingFlow();
});

function initializePricingFlow() {
  // SP版モーダルを開く
  const openButtonClasses = [
    'button.pricing-flow-btn-primary',
    'button.pricing-flow-btn-purchase-footer'
  ];
  const openButtons = document.querySelectorAll(openButtonClasses.join(', '));

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const dialogId = button.dataset.dialogId;
      const dialog = document.getElementById(dialogId);

      if (dialog) {
        ModalManager.enqueue(new DialogAdapter(dialog, ModalPriority.PRICING_FLOW));
      }
    });
  });

  // SP版モーダルを閉じる
  const closeButtons = document.querySelectorAll('.dialog-sp-close');

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const dialogId = button.dataset.dialogId;
      const dialog = document.getElementById(dialogId);

      if (dialog) dialog.close();
    });
  });

  // モーダルの背景クリックで閉じる
  const dialogs = document.querySelectorAll('.dialog-sp');

  dialogs.forEach((dialog) => {
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });
  });
}
